import * as React from 'react'
import { Col, Row } from 'react-bootstrap';
import PopoverTemplate from '@nkr/components/popover-template';
import styled from 'styled-components';

const PopoverWrapper = styled(PopoverTemplate) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
    
    & > div {
        font-size: 12px;
    }
`;

const informationOverlay = (
    <PopoverWrapper title={<h4>Guide to Donor Mentor</h4>}>
        <div>
            <Row>
                <Col xs={12} lg={1}>
                    <div style={{ height: 20, width: 20, backgroundColor: '#ff8080', border: '1px solid #000000', borderRadius: 4 }}></div>
                </Col>
                <Col xs={12} lg={4} style={{ marginTop: 3 }}>Opted to Stop Communication</Col>
            </Row>

            <h5 style={{ fontSize: 16 }}>Tab Information</h5>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>UNASSIGNED</Col>
                <Col xs={12} lg={9}>All tickets where the counselor has not yet been assigned</Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>TO DO</Col>
                <Col xs={12} lg={9}>All tickets that are assigned to the current user and not closed or the next follow-up date is empty or has already passed</Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>ASSIGNED TO ME</Col>
                <Col xs={12} lg={9}>All tickets assigned to the current user that are not closed</Col>
            </Row>

            <Row style={{ marginBottom: 20 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>ALL</Col>
                <Col xs={12} lg={9}>All tickets regardless of status or next follow-up date</Col>
            </Row>

            <h5 style={{ fontSize: 16 }}>Additional Information</h5>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>Next Follow-Up Date</Col>
                <Col xs={12} lg={9}>
                    <div>This is one of the following:</div>
                    <ul>
                        <li>The next follow-up date if set, or</li>
                        <li>Two (2) days after the donor opted-in to Donor Mentor, or</li>
                        <li>Two (2) days from the current date</li>
                    </ul>
                </Col>
            </Row>

            <Row>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>Assigned Mentor</Col>
                <Col xs={12} lg={9}>
                    <div>The numbers after the name in the list are:</div>
                    <div style={{ paddingLeft: 30 }}>CURRENT ACTIVE CASES / CASE LOAD LIMIT</div>
                </Col>
            </Row>
        </div>
    </PopoverWrapper>
);

export default informationOverlay;